import React, { Component } from "react";
import { connect } from "react-redux";

import { sendMessage, setConversation } from "../../actions/message";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import UserInfo from "../../services/user-info";

import Rate from "../rate/rate";
import ButtonPrint from "../buttonPrint/buttonPrint";
import CommonHelper from "../../helpers/common";
import ColorHelper from "../../helpers/colorHelper";

import "./chat-actions.scss";
import { getUser } from '../../actions/authentication';
import { clearUser } from '../../actions/authentication';
import { initConversation } from "../../actions/app";
import AuthenticationService from '../../services/authentication-service';
import { uuid as uuidv4 } from 'uuidv4';
class ChatAction extends Component {
  state = {
    singleHide: true,
  };

  checkListOptions = [];

  messageChecklist;

  static getDerivedStateFromProps(newProps, prevState) {
    return { singleHide: newProps.actionData.singleHide };
  }

  actions = {
    list: () => this.listRender(),
    buttons: () => this.buttonsRender(),
    quick_replies: () => this.quickReplieRender(),
    rate: () => this.rateRender(),
    checklist: () => this.checklistRender(),
  };

  closeLoading = () => {
    this.setState({
      loading: false
    })
  }

  types = {
    map: (value, index) => this.mapHandler(value, index),
    web_url: (value, index) => this.webUrlHandler(value, index),
    postback: (value, index) => this.postbackHandler(value, index),
  };

  constructor(props) {
    super(props);

    this.checkHide = this.checkHide.bind(this);
    this.getAction = this.getAction.bind(this);
    this.mapHandler = this.mapHandler.bind(this);
    this.rateRender = this.rateRender.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.webUrlHandler = this.webUrlHandler.bind(this);
    this.buttonsRender = this.buttonsRender.bind(this);
    this.postbackHandler = this.postbackHandler.bind(this);
    this.checklistRender = this.checklistRender.bind(this);
    this.enviarCheckListParaWatson = this.enviarCheckListParaWatson.bind(this);
    const userDataDom = document.getElementById("omni-chat-script");
    this.state = {
      verified: false,
      alreadyGettedToken: false,
      showSSOIframe: false,
      clientIframeUrl: null,
      code: userDataDom ? userDataDom.getAttribute("data-code") : null,
      token: null,
      isShowedGovLogin: false,
      isOpenLogin: false,
      loading: false,
      hover: -1,
      appBrowserClosed: false
    };
  }

  mapHandler(value, index) {
    if (typeof value !== "object") return false;

    const target = value.self ? "_self" : "_blank";
    return (
      <a className="map-button" key={index} target={target} href={value.url}>
        {value.title}
      </a>
    );
  }

  postbackHandler(value, index) {
    let onClickClass = "";

    if (typeof value !== "object") return false;
    if (
      this.props.messages.length !== this.props.position + 1 &&
      this.props.actionType !== "list"
    ) {
      return false;
    }

    const buttonClass = `postback-button ${this.props.actionType} ${onClickClass}`;

    return (
      <button
        key={index}
        className={buttonClass}
        onClick={(e) =>
          this.sendMessage(e.currentTarget.parentNode, value.payload, index)
        }
      >
        {value.title}
      </button>
    );
  }

  webUrlHandler(value, index) {
    if (typeof value !== "object") return false;

    const target = value.self ? "_self" : "_blank";

    return (
      <a className="link buttons" key={index} target={target} href={value.url}>
        {value.title}
      </a>
    );
  }

  storeHide(buttonIndex) {
    const { position, actionType } = this.props;
    const newState = CommonHelper.cloneArray(this.props.messages);

    if (actionType !== "list") {
      newState[position].actions[actionType][buttonIndex].hide = true;
    }

    if (actionType === "list") {
      const list = newState[position].actions[actionType].map((action) => {
        action.hide = true;
        return action;
      });

      newState[position].actions[actionType] = list;
    }
    this.props.setConversation(newState);
  }

  handleClickViaCapturing(e) {
    let index = this.checkListOptions.indexOf(e.target.value);

    if (index > -1) {
      this.checkListOptions.splice(index, 1);
    } else {
      this.checkListOptions.push(e.target.value);
    }
  }

  enviarCheckListParaWatson() {
    this.messageChecklist = this.checkListOptions.toString();
    this.props.ws.emit(
      "customerSendMessageToBot",
      this.sendWebSocketObject(this.messageChecklist)
    );
  }

  sendMessage(node, message, buttonIndex, ammendWithContext = null) {
    if (this.props.actionType !== "list") {
      node.classList.add("omni-hide");
      this.storeHide(buttonIndex);
    }

    if (this.props.actionType === "list") {
      node.parentNode.classList.add("omni-hide");
      this.storeHide(buttonIndex);
    }

    this.props.ws.emit(
      "customerSendMessageToBot",
      this.sendWebSocketObject(message, ammendWithContext)
    );
    // this.props.sendMessage({ message });
  }

  // To emit message for authenticatedWithGovbr

  sendWebSocketObject = (message, ammendWithContext = null) => {
    let context = !CommonHelper.isEmpty(Object.assign(this.props.conversation, ammendWithContext)) ? this.props.conversation : {}
    if (context.data) delete context.data
    if (context.mount_link) delete context.mount_link
    return JSON.stringify({
      text: message,
      context,
      infosUser: UserInfo.getInfo(),
      isButton: true
      // inputDateTime: new Date()
    });
  }
  setStyleQuickReply = (bgColor, index) => {
    if (bgColor) {
      const { hover } = this.state;
      let backgroundColor = '';
      if (this.props.theme === 'light') {
        backgroundColor = hover === index ? new ColorHelper(bgColor).getColor().setAlpha(0.5) : bgColor
      } else {
        backgroundColor = hover === index ? '#e9f2fb' : 'white'
      }
      return {
        backgroundColor
      }
    }
  }

  quickReplieRender() {
    if (!(this.props.actionData instanceof Array)) return false;
    // @martini 2020-12-28 keep buttons quickReplies after timeout warn/terminate.
    // if (this.props.messages.length !== this.props.position + 1) {
    //   return false;
    // }
    const hasToRenderGovBr = this.props.actionData.some(value => value.actions === 'govbr')
    const hasLargeText = this.props.actionData.some(value => value.title.length > 25)
    if (this.props.actionData.length >= 3 || hasLargeText) {
      return (
        <div className="quick-reply-container-3">
          {this.props.actionData.map((value, index) => {
            return value.actions === 'govbr' ? this.govLoginButton(value.payload, index) : (
              <button title={value.title}
                key={index}
                className="quick-replies eds-style-text"
                style={this.setStyleQuickReply(value.bg_color, index)}
                onMouseEnter={() => this.setState({ hover: index })}
                onMouseLeave={() => this.setState({ hover: -1 })}
                onClick={(e) => {
                  this.sendMessage(
                    e.currentTarget.parentNode,
                    value.payload,
                    index
                  )
                }
                }
              >
                {value.title}
              </button>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className={hasToRenderGovBr ? "quick-reply-container-3" : "quick-reply-container"}>
          {this.props.actionData.map((value, index) => {
            return value.actions === 'govbr' ? this.govLoginButton(value.payload, index) : (
              <button title={value.title}
                key={index}
                className="quick-replies"
                style={this.setStyleQuickReply(value.bg_color, index)}
                onMouseEnter={() => this.setState({ hover: index })}
                onMouseLeave={() => this.setState({ hover: -1 })}
                onClick={(e) =>
                  this.sendMessage(
                    e.currentTarget.parentNode,
                    value.payload,
                    index
                  )
                }
              >
                {value.title}
              </button>
            );
          })}
        </div>
      );
    }
  }
  handleOpenGovLogin = (e, payload, index) => {
    this.setState({
      appBrowserClosed: false
    })
    localStorage.removeItem('omni_ifs_auth');
    localStorage.removeItem('omni_ifs_ts');

    const state = uuidv4();
    const redirect_uri = this.props.config.redirectUri
    const client_id = this.props.config.clientId
    const urlLoginPrefix = this.props.config.urlSso
    const response_type = this.props.config.responseType

    const url = `${urlLoginPrefix}?response_type=${response_type}&client_id=${encodeURIComponent(client_id)}&redirect_uri=${encodeURIComponent(redirect_uri)}&nonce=${uuidv4()}&state=${state}`
    let externalWindow = "";
    let code = ""
    let thisClass = this
    const isMobile = UserInfo.getInfo().isMobile;
    const isApp = localStorage.getItem('ifs_platform') === 'cordova';
    console.log(`[handleOpenGovLogin] => isMobile =${isMobile} isApp=${isApp}`)
    if (isMobile && isApp) {
      externalWindow = window.open(url, 'janela', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800,beforeload=get');
    } else {
      externalWindow = window.open(url, 'janela', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800');
    }
    if (externalWindow) {
      if (isMobile && isApp) {
        console.log('[externalWindow, isMobile, isApp ]')
        externalWindow.addEventListener('beforeload', async (params, callback) => {
          console.log(`[externalWindow, isMobile, isApp beforeload ] ${JSON.stringify(params)}`)
          code = new URL(params.url).searchParams.get('code')
          if (params.url.indexOf('digital/authorize') !== -1) {
            await new  AuthenticationService().send(code, state).then(async () => {
              await thisClass.props.getUser(state)
            }).catch((error) => {
              console.log(`[addEventListener  beforeload condition digital/authorize error ${JSON.stringify(error)}]`)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            })
          }
          callback(params.url)
        });
        var timerMobile = setInterval(async function () {
          setTimeout(async () => {
            console.log(`[setTimeout  externalWindow condition ${JSON.stringify(thisClass.props.user)}]`)
            if (Object.keys(thisClass.props.user).length !== 0 && thisClass.props.user.type === 'Success') {
              console.log('[setTimeout  externalWindow condition - Success]')
              clearInterval(timerMobile)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            } else if (Object.keys(thisClass.props.user).length !== 0 && thisClass.props.user.type === 'sessionNotFound') {
              await new AuthenticationService().send(code, state).then(
                  async () => {
                    await thisClass.props.getUser(state)
                  }
              ).catch((error) => {
                console.log(`[setTimeout  externalWindow condition - sessionNotFound error ${JSON.stringify(error)}]`)
                externalWindow.close()
                clearInterval(timerMobile)
                thisClass.setState({
                  appBrowserClosed: true
                })
              })
              console.log('[setTimeout  externalWindow condition - sessionNotFound]')
              clearInterval(timerMobile)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            }
          }, 2000)
        }, 3000);
        externalWindow.addEventListener('exit', () => {
          setTimeout(() => {
            thisClass.closeLoading()
            clearInterval(timerMobile)
          }, 4000)
        })
      } else {
        var timer = setInterval(function () {
          if (externalWindow.closed) {
            clearInterval(timer)
            thisClass.props.getUser(state)
          }
        }, 500);
      }
    }

    /**
     * To get user data after getUser
     */
    const newPopupIntervalId = setInterval(() => {
      if (externalWindow.closed || this.state.appBrowserClosed) {
        if (thisClass.props.user === null) {
          clearInterval(newPopupIntervalId);
          thisClass.props.clearUser()
          payload = 'govBrNoUser'
          this.sendMessage(e, payload, index)
        } else {
          if (thisClass.props.user.hasOwnProperty('name') && thisClass.props.user.hasOwnProperty('cpf')) {
            thisClass.closeLoading()
            clearInterval(newPopupIntervalId);
            const user = thisClass.props.user
            const auth = new AuthenticationService()
            auth.setToken()
            auth.setExpiration()
            // To calling init chat function
            thisClass.handleInit.bind(thisClass)({
              userName: user.name,
              cpf: user.cpf,
              user_token: this.state.token,
              user_id: this.state.sysId,
              authenticated: "govbr"
            }, true)
            payload = 'govBrSuccess'
            let ammendWithContext = {
              userName: user.name,
              cpf: user.cpf,
              session_nome: user.name,
              session_cpf: user.cpf,
              user_token: this.state.token,
              user_id: this.state.sysId,
              authenticated: "govbr",
              state: state,
              govBrNewAuth: true
            }
            setTimeout(() => this.sendMessage(e, payload, index, ammendWithContext), 1000)
          } else {
            if (Object.keys(thisClass.props.user).length > 0) {
              if (thisClass.props.user.type === 'embededSeals') {
                payload = 'govBrLoginErrorSeals'
                this.sendMessage(e, payload, index)
              } else {
                payload = 'govBrLoginError'
                this.sendMessage(e, payload, index)
              }
              clearInterval(newPopupIntervalId);
              thisClass.props.clearUser()
            }
          }
        }
      }
    }, 500);

    this.setIsShowedGovLogin()
  }
  handleOpenModal(message = '') {
    this.props.toggleModalChat(true, message, () => null, () => null);
  }
  setIsShowedGovLogin = () => {
    this.setState({
      isShowedGovLogin: true,
      loading: true,
      isOpenLogin: true,
    })
  }

  handleInit(formUserData, custom = false) {
    // Bug: #93588
    localStorage.removeItem("auth")

    if (this.props.config.isCaptchaActive && !this.state.verified) {
      return false;
    }
    const userData = {
      user_id: formUserData ? formUserData.user_id : "",
      user_token: this.state.token
        ? this.state.token
        : formUserData
          ? formUserData.user_token
          : "",
      userName: this.state.userName ? this.state.userName : "",
      cpf: this.state.cpf,
      sysId: this.state.sysId,
    };

    // Bug: #93588
    if (custom && this.props.config.isGovAuthEnable) {
      userData.cpf = formUserData.cpf
      userData.userName = formUserData.userName
      localStorage.setItem("auth", formUserData.authenticated);
    }
    localStorage.setItem("userName", userData.userName);
    localStorage.setItem("cpf", userData.cpf);
    localStorage.setItem("user_id", userData.user_id);
    localStorage.setItem("user_sysId", userData.sysId);
    localStorage.setItem("user_token", userData.user_token);
    // this.props.initConversation(userData);
  }

  govLoginButton = (payload, index) => {
    const fields = (
      <button
        key={index}
        title="Entrar com o Gov br"
        className="br-button omni-button gov-button"
        type="button"
        aria-label="Entrar com o Gov br"
        onClick={(e) => {
          this.handleOpenGovLogin(e.currentTarget.parentNode, payload, index)
          e.currentTarget.disabled = true
        }}
      >
        <img id="govbr-img2" alt="Entrar via GovBr" src="https://sso.acesso.gov.br/assets/govbr/img/govbr.png" />
      </button>
    );

    return fields
  }

  checklistRender() {
    if (!(this.props.actionData instanceof Array)) return false;
    if (this.props.messages.length !== this.props.position + 1) {
      return false;
    }
    return (
      <>
        <div className="ckeckbox-container">
          {this.props.actionData.map((value, index) => {
            return (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="value.title"
                      key={index}
                      onChange={(e) => this.handleClickViaCapturing(e)}
                      value={value.title}
                      color="primary"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  }
                  label={value.title}
                />
                <br />
                <br />
              </>
            );
          })}
        </div>
        <button
          className="quick-replies"
          onClick={this.enviarCheckListParaWatson}
        >
          Continuar
        </button>
      </>
    );
  }

  buttonsRender() {
    if (!(this.props.actionData instanceof Array)) return false;
    return this.props.actionData.map((value, index) =>
      this.types[value.type](value, index)
    );
  }

  listRender() {
    if (!(this.props.actionData instanceof Array)) return false;
    return (
      <ul>
        {this.props.actionData.map((value, index) => {
          if (!value.buttons) return false;
          value.buttons[0].title = value.title;
          return (
            <li key={index} title={value.title}>
              {this.types[value.buttons[0].type](value.buttons[0])}
            </li>
          );
        })}
      </ul>
    );
  }

  rateRender() {
    return (
      <>
        <Rate />
        <ButtonPrint config={this.props.config} />
      </>
    );
  }

  getAction() {
    return this.actions[this.props.actionType]();
  }

  checkHide() {
    let hasHide = false;

    if (this.props.actionType === "rate") return false;

    this.props.actionData.forEach((value) => {
      if (value.hide) hasHide = true;
    });

    return hasHide;
  }

  render() {
    if (this.checkHide()) return false;

    return <div className="chat-action">{this.getAction()}</div>;
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  messages: state.messages,
  conversation: state.conversation,
  user: state.authentication,
  theme: state.theme
});

const mapDispatchToProps = (dispatch) => ({
  clearUser: () => dispatch(clearUser()),
  getUser: (state) => dispatch(getUser(state)),
  initConversation: (config) => dispatch(initConversation(config)),
  sendMessage: (message) => dispatch(sendMessage(message, "client")),
  setConversation: (conversation) => dispatch(setConversation(conversation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatAction);
